import { ArrowUpRight, Clock, Layers } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const services = [
  {
    title: "Séance individuelle",
    description:
      "Un temps de travail ciblé sur une problématique précise pour clarifier une situation, identifier un mécanisme actif et amorcer une restructuration.",
    metaLeft: { icon: Clock, label: "1h15" },
    metaRight: { label: "95 €" },
    cta: "Prendre rendez-vous",
    accent: false,
  },
  {
    title: "Séance approfondie",
    description:
      "Un travail en profondeur sur les psychotraumas, schémas émotionnels, blessures anciennes, enfant intérieur et mémoires familiales.",
    metaLeft: { icon: Clock, label: "2h" },
    metaRight: { label: "150 €" },
    cta: "Réserver cette séance",
    accent: true,
  },
  {
    title: "Accompagnement sur plusieurs séances",
    description:
      "Un travail progressif pour les problématiques installées, les schémas répétitifs ou les situations qui demandent un suivi plus structuré.",
    metaLeft: { icon: Layers, label: "3 ou 5 séances" },
    metaRight: { label: "Sur devis" },
    cta: "En savoir plus",
    accent: false,
  },
];

export default function Services({ onBookingClick }) {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 bg-[#FAF7F8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              — Accompagnements individuels
            </span>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light mt-4 max-w-xl leading-[1.05]">
              Les accompagnements individuels
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-base text-[#5F6170] max-w-md">
              Trois formats pensés pour s'adapter à votre situation, qu'il s'agisse d'éclairer
              une question ponctuelle ou d'engager un travail de fond.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = s.metaLeft.icon;
            return (
              <Reveal key={s.title} delay={i * 0.08}>
                <article
                  data-testid={`service-card-${i}`}
                  className={`relative h-full p-8 md:p-10 rounded-3xl border transition-all duration-300 flex flex-col ${
                    s.accent
                      ? "bg-[#3A2E6E] border-[#3A2E6E] text-white shadow-[0_30px_60px_-20px_rgba(58,46,110,0.45)]"
                      : "bg-white border-[#DDD7E2] hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(40,71,184,0.08)]"
                  }`}
                >
                  {s.accent && (
                    <span className="absolute top-6 right-6 text-[10px] uppercase tracking-[0.2em] px-3 py-1 rounded-full bg-[#C98FA3] text-white">
                      Recommandé
                    </span>
                  )}
                  <h3
                    className={`font-serif-display text-3xl font-light leading-tight ${
                      s.accent ? "text-white" : "text-[#1E1E2A]"
                    }`}
                  >
                    {s.title}
                  </h3>
                  <p
                    className={`mt-5 text-sm md:text-base leading-relaxed flex-grow ${
                      s.accent ? "text-white/80" : "text-[#5F6170]"
                    }`}
                  >
                    {s.description}
                  </p>

                  <div
                    className={`mt-8 pt-6 border-t flex items-center justify-between ${
                      s.accent ? "border-white/15" : "border-[#DDD7E2]"
                    }`}
                  >
                    <div
                      className={`flex items-center gap-2 text-sm ${
                        s.accent ? "text-white/70" : "text-[#5F6170]"
                      }`}
                    >
                      <Icon className="w-4 h-4" />
                      {s.metaLeft.label}
                    </div>
                    <span
                      className={`font-serif-display text-2xl ${
                        s.accent ? "text-[#E6D6DF]" : "text-[#3A2E6E]"
                      }`}
                    >
                      {s.metaRight.label}
                    </span>
                  </div>

                  <button
                    onClick={onBookingClick}
                    data-testid={`service-cta-${i}`}
                    className={`mt-6 inline-flex items-center justify-between gap-2 px-6 py-3 rounded-full font-medium text-sm transition-all duration-300 ${
                      s.accent
                        ? "bg-white text-[#3A2E6E] hover:bg-[#E6D6DF]"
                        : "bg-[#2847B8] text-white hover:bg-[#3A2E6E]"
                    }`}
                  >
                    {s.cta}
                    <ArrowUpRight className="w-4 h-4" />
                  </button>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
